import React, { useContext, createContext, ReactNode } from 'react';
import { loadStripe, Stripe, StripeElements } from '@stripe/stripe-js';
import { Elements, ElementsConsumer } from '@stripe/react-stripe-js';

const StripeContext = createContext<{stripe: Stripe | null, elements: StripeElements |null}>({ elements: null, stripe: null});

interface Props {
    children?: ReactNode
}

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY as string);

export const StripeProvider = (props: Props) => (
    <Elements stripe={stripePromise}>
        <InjectedStripe>{props.children}</InjectedStripe>
    </Elements>
)

const InjectedStripe = (props: Props) => {
    return (
    <ElementsConsumer>
        {({ stripe, elements }) => (<StripeContext.Provider value={{ stripe, elements }}>
            {props.children}
        </StripeContext.Provider>)}
    </ElementsConsumer>
    )
}

export const useStripeContext = () => useContext(StripeContext)


